import { useEffect, useState } from "react";
import Api from "../../../Api";
import { useTranslation } from "react-i18next";
import GetAllUsersRequest from "../requests/GetAllUsersRequest";
import GetTeamUsers from "../requests/GetTeamUsers";
import CreateUserDialog from "./CreateUserDialog";
import { TeambookUsersPicker } from "../../default_components/TeambookDefaultPickers";
import DeleteUserFromTeamRequest from "../requests/DeleteUserFromTeamRequest";
import WarningModal from "../../default_components/WarningModal";
import { shallow } from "zustand/shallow";
import { useNotificationStore } from "../../../stores/notificationStore";
import PropTypes from "prop-types";
import TeambookDialog from "../../default_components/TeambookDialog";

const AddUserDialog = ({ open, handleClose, teamId, teams, setAddUser }) => {
  const currentTeam = teams?.find((team) => team.id === teamId);

  const { t } = useTranslation();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [allUsers, setAllUsers] = useState();
  const [teamUsers, setTeamUsers] = useState();
  const [addUserWindowOpen, setAddUserWindowOpen] = useState(false);
  const [submitDisable, setSubmitDisable] = useState(false);
  const [createdUsers, setCreatedUsers] = useState([]);
  const [creatingUserName, setCreatingUserName] = useState("");
  const [closeConfrimationWindowOpened, setCloseConfirmationWindowOpened] = useState(false);
  const [setInAppNotification] = useNotificationStore((state) => [state.setInAppNotification], shallow);

  const profileRole = localStorage.getItem("tb-role") || "regular";

  useEffect(() => {
    if (open) {
      GetAllUsersRequest(setAllUsers);
      GetTeamUsers(setTeamUsers, teamId);
    }
  }, [open, addUserWindowOpen]);

  const addUserToSelected = (users) => {
    let deletedUser = selectedUsers.filter((x) => !users.includes(x));
    if (deletedUser.length) {
      const [user] = deletedUser;
      if (user.created) {
        DeleteUserFromTeamRequest(teamId, [user.id], false);
      }
    }

    setSelectedUsers(users);
  };

  const filterUsers = () => {
    let filteredUsers = allUsers.filter((user) => {
      user.value = user.first_name + user.id;
      return user.active === true;
    });

    if (teamUsers === null) {
      return filteredUsers;
    }

    filteredUsers = filteredUsers.filter((user) => {
      return !teamUsers
        .map((u) => {
          return u.id;
        })
        .includes(user.id);
    });

    return filteredUsers;
  };

  const addUsers = () => {
    let userIds = selectedUsers
      .filter(({ created }) => !created)
      .map((user) => {
        return parseInt(user.id);
      })
      .filter((userId) => {
        return !currentTeam.team_users.includes(userId);
      });
    handleClose();

    if (userIds.length > 0) {
      setSubmitDisable(true);

      Api.Teams.add_users(teamId, userIds).then((response) => {
        const updatedTeam = response.data;

        setSelectedUsers([]);
        setAddUser(true);
        setSubmitDisable(false);

        if (createdUsers.length !== 0 || selectedUsers.length !== 0) {
          setInAppNotification(`${t("notifications.planning.add_users_to_team")} ${updatedTeam.name}`);
        }
      });
    }
  };

  const closeCreationWindow = () => {
    handleClose();
    setSelectedUsers([]);

    if (createdUsers.length) {
      setCreatedUsers([]);
    }
  };

  return (
    <>
      <TeambookDialog
        onClose={closeCreationWindow}
        title={t("planning.add_user_text")}
        open={open}
        withCloseButton
        content={
          <>
            {allUsers && teamUsers !== undefined && teams && (
              <TeambookUsersPicker
                nameStyles={{ margin: "5px auto" }}
                fieldName={t("planning.select_users")}
                onChange={(newUser) => addUserToSelected(newUser)}
                users={filterUsers()}
                classNamePrefix="tb-react-select"
                closeMenuOnSelect={false}
                value={selectedUsers}
                type="multiple"
                placeholder=""
                onCreateOption={(option) => {
                  setCreatingUserName(option);
                  setAddUserWindowOpen(!addUserWindowOpen);
                }}
                isSearchable={true}
                isCreatable={true}
              />
            )}
          </>
        }
        actionButtons={[
          {
            text: t("save"),
            onClick: addUsers,
            disabled: submitDisable
          }
        ]}
      />

      {addUserWindowOpen && (
        <CreateUserDialog
          open={addUserWindowOpen}
          setAddUserWindowOpen={setAddUserWindowOpen}
          profileRole={profileRole}
          teamId={teamId}
          selectedUsers={selectedUsers}
          currentTeam={currentTeam}
          creatingUserName={creatingUserName}
          setCreatedUsers={setCreatedUsers}
          setCreatingUserName={setCreatingUserName}
          handleClose={handleClose}
          setAddUser={setAddUser}
        />
      )}

      {closeConfrimationWindowOpened && (
        <WarningModal
          onNo={() => {
            handleClose();
            setSelectedUsers([]);
            setCloseConfirmationWindowOpened(false);
          }}
          closeModal={() => setCloseConfirmationWindowOpened(false)}
        />
      )}
    </>
  );
};

AddUserDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  teamId: PropTypes.number,
  teams: PropTypes.array,
  setAddUser: PropTypes.func,
}

export default AddUserDialog;
